import { lazy } from 'react';

// ----------------------------------------------------------------------

// Envuelve React.lazy para manejar ChunkLoadError tras un nuevo deploy.
// Cuando el index.html en cache apunta a un chunk con hash viejo que ya
// no existe en el hosting, el import dinamico falla (ChunkLoadError /
// ERR_CONNECTION_CLOSED) y la pantalla queda en blanco. En ese caso
// forzamos un unico reload para cargar el index.html + chunks nuevos.

const RETRY_FLAG = 'chunk-reload-attempted';

function isChunkLoadError(error) {
  return (
    error &&
    (error.name === 'ChunkLoadError' ||
      /Loading (CSS )?chunk [\d]+ failed/i.test(error.message || '') ||
      /Failed to fetch dynamically imported module/i.test(error.message || ''))
  );
}

export function lazyWithRetry(componentImport) {
  return lazy(async () => {
    try {
      const component = await componentImport();
      // Import exitoso: limpiamos el flag para futuros deploys.
      window.sessionStorage.removeItem(RETRY_FLAG);
      return component;
    } catch (error) {
      if (isChunkLoadError(error)) {
        const alreadyReloaded = window.sessionStorage.getItem(RETRY_FLAG);
        if (!alreadyReloaded) {
          window.sessionStorage.setItem(RETRY_FLAG, 'true');
          window.location.reload();
          // Devolvemos una promesa que nunca resuelve mientras recarga,
          // para evitar que Suspense muestre nada intermedio.
          return new Promise(() => {});
        }
      }
      throw error;
    }
  });
}
